/**
 * Generic analytics functions so we can swap out 3rd party analtyics more easily.
 * i.e. we can change from Mixpanel to Metarouter or add GA
 */
import mixpanel from 'mixpanel-browser';
import { featureFlagClient, isFlagEnabled, isVariantEnabled } from '../featureFlags';

/**
 * Get all variation ids from a campaign
 * @returns {array} - an array of all variation ids
 */
export const getExperimentVariationIds = () => {
  // feature flag client has not initialized yet or errored
  if (!featureFlagClient.readyEventEmitted) {
    return null;
  }

  const toggles = featureFlagClient.getAllToggles();
  const variationIds = toggles
    .filter(toggle => isFlagEnabled(toggle) && isVariantEnabled(toggle.variant))
    .map(toggle => ({ id: toggle.name, variant: toggle.variant.name }));

  return variationIds;
};

/**
 * Send an analtyics event
 * @param {string} eventName
 * @param {*} props - an object with event properties
 * @param {boolean} shouldSendVariantID - a bollean to indicate if we should append the experiment variant id
 */
export const sendAnalyticsEvent = (eventName, props = {}, shouldSendVariantID = true) => {
  // append variation id if the event wants it, and if it exists
  try {
    if (shouldSendVariantID) {
      const variationIds = getExperimentVariationIds();
      if (variationIds) {
        props.unleash_ab_test_ids = variationIds;
      }
    }
    mixpanel.track(eventName, props);
  } catch (e) {
    console.error(e);
  }
}

/**
 * Send a page view event
 * @param {string} eventName - The page view event name
 */
export const sendPageViewEvent = eventName => {
  sendAnalyticsEvent(eventName, {
    app: 'web-site',
    page_URL: window.location.pathname,
  });
};

export const getAnalyticsPlanType = (plan) => plan.planDataKey;



// WEBPACK FOOTER //
// ./src/services/analytics.js